module.exports = __webpack_public_path__ + "static/media/job_time.8208f504.svg";